import React from "react";
import { Survey, ScoredSelectionStats, QuestionReportDataSet, SurveySegment } from "../../../../../../../amorg-common";
import { surveyQuestionHelper } from "../../../../../../../amorg-common/helpers/surveyQuestionHelper";
import { Button } from "../../../../../../../designSystem/button/Button";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import { ListRowWithChildren } from "../../../../../../../designSystem/compositeComponents/ListRow";
import { NoDataSurveyAnswerScoreRadialChart, AggregatedSurveyAnswerScoreRadialChart } from "../../../../../../../designSystem/graphs/SurveyAnswerScoreRadialChart";
import { QuestionPanel } from "./QuestionPanel";
import { NoQuestionsSurveyAnswerRatioBar, NoAnswersSurveyAnswerRatioBar, NoScoredAnswersSurveyAnswerRatioBar, AggregatedSurveyAnswerRatioBar } from "./SurveyAnswerRatioBar";
import { RadialPieChart } from "../../../../../../../designSystem/graphs/RadialPieChart";
import { colors } from "../../../../../../../designSystem/colors/color";

type QuestionSummaryPanelProps = {
    survey:Survey,
    siteId:string,
    header:React.ReactNode,
    summaryStats:ScoredSelectionStats,
    questions:QuestionReportDataSet[],
    segmentFilter:SurveySegment[][],
    showComments:boolean,
}
export function QuestionSummaryPanel(props:QuestionSummaryPanelProps): JSX.Element 
{
    const [expanded, setExpanded] = React.useState(false);

    let resultType: 'no-questions' | 'no-answers' | 'scored-answers' | 'non-scored-answers' = 'no-questions';
    if(props.questions.length === 0)
    {
        resultType = 'no-questions';
    }
    else {
        // Looking at stats will yield a false positive, since the stats are aggregated for scored questions only.
        // There may still be non-scored questions with answers.
        if(props.survey.answerCount === 0)
        {
            resultType = 'no-answers';
        }
        else {
                if(props.questions.some(q => surveyQuestionHelper.isScoredQuestion(q.question)))
            {
                resultType = 'scored-answers';
            }
            else
            {
                resultType = 'non-scored-answers';
            }
        }
    }
    
    return (
        <ListRowWithChildren styleVariant="neutral" sizeVariant="medium" expanded={expanded}
            content={
                <Flex justifyContent='space-between'>

                    <div style={{display:'flex', width:200}}>
                        
                        {resultType === 'no-questions' &&
                            <NoDataSurveyAnswerScoreRadialChart />
                        }

                        {resultType === 'no-answers' &&
                            <NoDataSurveyAnswerScoreRadialChart />
                        }

                        {resultType === 'non-scored-answers' &&
                            <RadialPieChart segments={[ { value:1, color:colors.graphs.survey.noScore} ]} value="" />
                        }
                        
                        {resultType === 'scored-answers' &&
                            <AggregatedSurveyAnswerScoreRadialChart stats={props.summaryStats} />
                        }
                        
                    </div>

                    <div style={{display:'flex', flexDirection:'column', flexGrow:1}}>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            {props.header}
                        </div>

                        <div style={{ width: '100%' }}>

                            {resultType === 'no-questions' &&
                                <NoQuestionsSurveyAnswerRatioBar />
                            }
                            
                            {resultType === 'no-answers' &&
                                <NoAnswersSurveyAnswerRatioBar />
                            }

                            {resultType === 'non-scored-answers' &&
                                <NoScoredAnswersSurveyAnswerRatioBar />
                            }

                            {resultType === 'scored-answers' &&
                                <AggregatedSurveyAnswerRatioBar stats={props.summaryStats} />
                            }

                        </div>

                        <div style={{display:'flex', justifyContent:'flex-end', gap:10}}>
                            <Button variant='text'
                                icon={ expanded ? 'arrows_chevron_chevronUp' : 'arrows_chevron_chevronDown' } onClick={() => setExpanded(!expanded)} />
                        </div>
                    </div>
                </Flex>
            }
            childRows={
                <>
                    {props.questions.map((q, i) =>
                        <QuestionPanel key={i}
                            siteId={props.siteId}
                            question={props.questions[i].question}
                            data={q}
                            surveyId={props.survey.id}
                            segmentFilter={props.segmentFilter}
                            showCommentsButton={props.showComments} />
                    )}
                </>
            } 
        />
    );
}